<script>
  import ChoiceInput from './choice-input.svelte';

  export let value;

  export let onChange = () => {};

  const options = [
    { value: 'left', icon: 'align-left' },
    { value: 'center', icon: 'align-center' },
    { value: 'right', icon: 'align-right' },
    { value: 'justify', icon: 'align-justify' }
  ];
</script>

<ChoiceInput {value} {options} {onChange} />
